import { useQuery } from "react-query";
import { api } from "utils/api";
import { submissionKeys } from "./queryKeys";
import type { SubmissionsForVotingResp } from "../types";

const getSubmissionsForVoting = (
  openCallId?: string,
  firstSubmissionId?: string,
) =>
  openCallId
    ? api.get<SubmissionsForVotingResp>(
        firstSubmissionId
          ? `/open-call/community-voting/${openCallId}/submissions?createdByUserId=${firstSubmissionId}`
          : `/open-call/community-voting/${openCallId}/submissions`,
      )
    : Promise.reject(new Error("Invalid open call id."));

const useSubmissionsForVoting = (
  openCallId?: string,
  firstSubmissionId?: string,
) =>
  useQuery(
    submissionKeys.voting(openCallId, firstSubmissionId),
    () => getSubmissionsForVoting(openCallId, firstSubmissionId),
    {
      // Don't start until the open call is loaded
      enabled: !!openCallId,
      // NOTE: Never refetch, it will rearrange the values because they're randomized on the backend
      staleTime: Infinity,
    },
  );

export { useSubmissionsForVoting };
